import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=1461d9c2"
import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports